export const artifactsLabelMap: any = {
  crf: "Datasheet",
  screener: "Screening",
  econsent: "Econsent",
  sunshine: "Sunshine",
};

export const artifactsTypes = [
  {
    key: "crf",
    label: "Datasheet",
  },
  {
    key: "screener",
    label: "Screening",
  },
  {
    key: "econsent",
    label: "Econsent",
  },
  {
    key: "sunshine",
    label: "Sunshine",
  },
];
